import { render, staticRenderFns } from "./SavedReportForm.vue?vue&type=template&id=877b19b0&scoped=true"
import script from "./SavedReportForm.vue?vue&type=script&lang=js"
export * from "./SavedReportForm.vue?vue&type=script&lang=js"
import style0 from "./SavedReportForm.vue?vue&type=style&index=0&id=877b19b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "877b19b0",
  null
  
)

export default component.exports